<template>
  <div>
    <el-dialog
      :title="this.isCreated ? '新增任务配置' : '编辑任务配置'"
      center
      :visible="true"
      @close="onClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="701px"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="100px"
        size="mini"
        style="margin-right: 50px"
      >
        <el-form-item label="ID：" prop="id">
          <el-input
            style="width: 80px"
            :disabled="!isCreated"
            v-model="form.id"
          ></el-input>
        </el-form-item>
        <el-form-item label="目标类型：" prop="goalType">
          <el-input style="width: 80px" v-model="form.goalType"></el-input>
          <el-tooltip
            effect="dark"
            placement="top"
            v-if="isFinishedLoadData"
            style="margin-left: 10px"
          >
            <div slot="content" style="white-space: pre-wrap">
              {{ this.microfilmMap["heroUpgradeTask-goalType"] }}
            </div>
            <span
              ><i class="el-icon-question" style="font-size: 1.2em"></i
            ></span>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="类型判断：" prop="typeDetermination">
          <el-input
            style="width: 80px"
            v-model="form.typeDetermination"
          ></el-input>
          <el-tooltip
            effect="dark"
            placement="top"
            v-if="isFinishedLoadData"
            style="margin-left: 10px"
          >
            <div slot="content" style="white-space: pre-wrap">
              {{ this.microfilmMap["heroUpgradeTask-typeDetermination"] }}
            </div>
            <span
              ><i class="el-icon-question" style="font-size: 1.2em"></i
            ></span>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="任务条件1：" prop="schedule1">
          <el-input style="width: 80px" v-model="form.schedule1"></el-input>
          <el-tooltip
            effect="dark"
            placement="top"
            v-if="isFinishedLoadData"
            style="margin-left: 10px"
          >
            <div slot="content" style="white-space: pre-wrap">
              {{ this.microfilmMap["heroUpgradeTask-schedule1"] }}
            </div>
            <span
              ><i class="el-icon-question" style="font-size: 1.2em"></i
            ></span>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="任务条件2：" prop="schedule2">
          <el-input style="width: 80px" v-model="form.schedule2"></el-input>
          <el-tooltip
            effect="dark"
            placement="top"
            v-if="isFinishedLoadData"
            style="margin-left: 10px"
          >
            <div slot="content" style="white-space: pre-wrap">
              {{ this.microfilmMap["heroUpgradeTask-schedule2"] }}
            </div>
            <span
              ><i class="el-icon-question" style="font-size: 1.2em"></i
            ></span>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="跳转类型：" prop="jumpType">
          <el-input style="width: 80px" v-model="form.jumpType"></el-input>
          <el-tooltip
            effect="dark"
            placement="top"
            v-if="isFinishedLoadData"
            style="margin-left: 10px"
          >
            <div slot="content" style="white-space: pre-wrap">
              {{ this.microfilmMap["heroUpgradeTask-jumpType"] }}
            </div>
            <span
              ><i class="el-icon-question" style="font-size: 1.2em"></i
            ></span>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="任务描述：" prop="desc">
          <el-card>
            <base-desc @updated="updatedDesc" v-model="form.desc"></base-desc
          ></el-card>
        </el-form-item>
        <el-form-item label="奖励：">
          <base-item-selector
            @updated="updatedItemSelector"
            v-model="form.rewards"
          ></base-item-selector>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="this.onClose">取消</el-button>
        <el-button type="primary" @click="submit()">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const util = require("@/util");
import PayPointSelector from "@/components/PayPointSelector";
import BaseItemSelector from "../biz-components/BaseItemSelector";
import BaseDesc from "../biz-components/BaseDesc";

// 本弹窗名称
const DialogName = "EditHeroUpgradeTaskDialog";
export default {
  data() {
    return {
      form: {
        rewards: [],
      },
      microfilmMap: {},
      isCreated: false,
      itemSelectorResult: null,
      isFinishedLoadData: false,
    };
  },

  computed: {},

  async created() {
    let value = this.$dialogutil.getData(DialogName);
    if (value.entry != null) {
      this.form = value.entry;
    }
    this.isCreated = value.isCreated;

    await this.loadMicrofilmValue([
      "heroUpgradeTask-goalType",
      "heroUpgradeTask-typeDetermination",
      "heroUpgradeTask-schedule1",
      "heroUpgradeTask-schedule2",
      "heroUpgradeTask-jumpType",
    ]);
    console.log("microfilmMap", this.microfilmMap);
    this.isFinishedLoadData = true;
  },
  components: {
    PayPointSelector,
    BaseItemSelector,
    BaseDesc,
  },

  methods: {
    /**
     * 编辑线上活动
     * @param {*} entry
     */
    async submit() {
      if (this.isCreated) {
        await this.add();
      } else {
        await this.update();
      }
    },

    async add() {
      try {
        // 弹确认框
        await this.$confirm(
          `确认新增（该操作不会真的保存配置，需要在上一级页面中保存）？）`
        );

        let param = this.save();
        if (param.errMsg) {
          this.$message({
            message: param.errMsg,
            type: "error",
          });
          return;
        }
        this.$message({
          message: "新增成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onCloseWhitParam(param);
      } catch (e) {}
    },
    async update() {
      try {
        // 弹确认框
        await this.$confirm(
          `确认修改（该操作不会真的保存配置，需要在上一级页面中保存）？`
        );

        let param = this.save();

        if (param.errMsg) {
          this.$message({
            message: param.errMsg,
            type: "error",
          });
          return;
        }
        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onCloseWhitParam(param);
      } catch (e) {}
    },

    save() {
      if (this.itemSelectorResult.errMsg) {
        return { errMsg: this.itemSelectorResult.errMsg };
      }

      let rewards = this.itemSelectorResult;

      return {
        id: parseInt(this.form.id),
        goalType: parseInt(this.form.goalType),
        typeDetermination: parseInt(this.form.typeDetermination),
        schedule1: parseInt(this.form.schedule1),
        schedule2: parseInt(this.form.schedule2),
        jumpType: parseInt(this.form.jumpType),
        desc: this.form.desc,
        rewards: rewards,
      };
    },

    async onPayPointSelectorReady() {
      this.$refs.payPointSelector.payPoint = this.form.payPoint;
    },

    async onPayPointSelectorChange(newValue, oldValue) {
      this.form.payPoint = newValue;
    },

    async updatedItemSelector(param) {
      this.itemSelectorResult = param;
    },

    async updatedDesc(param) {
      this.form.desc = param;
    },

    async loadMicrofilmValue(keys) {
      for (let key of keys) {
        this.microfilmMap[key] = await this.$bizutil.queryMicrofilm(key);
      }
    },

    ms2ymdhm(ts) {
      return util.ms2ymdhm(ts);
    },

    onClose() {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName);
    },
    onCloseWhitParam(param) {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName, param);
    },
  },
};
</script>

<style lang="scss" scoped>
.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}
.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}
.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}
</style>

